/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateContactRequest
 */
export interface CreateContactRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateContactRequest
     */
    contactType: string;
    /**
     * 
     * @type {string}
     * @memberof CreateContactRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateContactRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateContactRequest
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateContactRequest
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateContactRequest
     */
    jobTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateContactRequest
     */
    notes?: string | null;
}

/**
 * Check if a given object implements the CreateContactRequest interface.
 */
export function instanceOfCreateContactRequest(value: object): value is CreateContactRequest {
    if (!('contactType' in value) || value['contactType'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function CreateContactRequestFromJSON(json: any): CreateContactRequest {
    return CreateContactRequestFromJSONTyped(json, false);
}

export function CreateContactRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateContactRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'contactType': json['contactType'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'jobTitle': json['jobTitle'] == null ? undefined : json['jobTitle'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function CreateContactRequestToJSON(json: any): CreateContactRequest {
    return CreateContactRequestToJSONTyped(json, false);
}

export function CreateContactRequestToJSONTyped(value?: CreateContactRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contactType': value['contactType'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'phone': value['phone'],
        'jobTitle': value['jobTitle'],
        'notes': value['notes'],
    };
}

